import { FC } from "react";

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const Youtube: FC<Props> = ({
  width = 24,
  height = 24,
  className,
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5928 7.20301C21.4795 6.78014 21.2571 6.39445 20.9479 6.08452C20.6386 5.7746 20.2535 5.55132 19.8308 5.43701C18.2648 5.00701 11.9998 5.00001 11.9998 5.00001C11.9998 5.00001 5.73584 4.99301 4.16884 5.40401C3.74677 5.52415 3.36266 5.75078 3.05341 6.06214C2.74415 6.3735 2.52013 6.75913 2.40284 7.18201C1.98984 8.74801 1.98584 11.996 1.98584 11.996C1.98584 11.996 1.98184 15.26 2.39184 16.81C2.62184 17.667 3.29684 18.344 4.15484 18.575C5.73684 19.005 11.9848 19.012 11.9848 19.012C11.9848 19.012 18.2498 19.019 19.8158 18.609C20.2381 18.4939 20.6231 18.2708 20.933 17.9617C21.2428 17.6525 21.4668 17.268 21.5828 16.846C21.9968 15.281 21.9998 12.034 21.9998 12.034C21.9998 12.034 22.0198 8.76901 21.5928 7.20301ZM9.99584 15.005L10.0008 9.00501L15.2078 12.01L9.99584 15.005Z"
        fill={color}
      />
    </svg>
  );
};

export default Youtube;
